import React from 'react';
import '../style/userLayout.css';
import useDelayedClose from '../hooks/useDelayedClose';
import BreadCrumb from './breadcrumb';
import {callbackHandler, isAdminUser, isAragUser} from '../helpers/functions';
import { LEGAL_ADVICE_TEXT, TOBA_PATH, TOBA_SHORT_TEXT } from '../helpers/variables';
import useFeatureFlag from '../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '../constants/configurationKeys';
import aragLogo from '../araglogo3@2x.png';
import {
	HorizontalRule,
	NavBar,
	NavBarMain,
	NavContainer,
	NavContent,
	NavHeader,
	NavLink,
	NavMenu,
	NavUser,
} from 'arag-ui-lib';
import CONTENT_STRINGS from '../helpers/contentStrings';

import {
	HEADER, SECONDARY,
	HREF_HOME, HREF_APPLICATION_AND_POLICIES, HREF_ADVANCE_DISBURSEMENTS,
	HREF_NOTIFICATIONS, HREF_NEW_USER, HREF_USERS, HREF_MANAGE_USER_ACCOUNT,
	HREF_EDITING_SETTINGS, HREF_REFERRAL_SETTINGS, HREF_ARTICLES, HREF_INTERNAL_ALERTS,
	HREF_SOLICITORS, PREMIUM_SETTINGS_URL
} from '../helpers/constants';


const LayoutHeader = (props) => {

	const {
		push,
		logout,
		locationPathName,
		userRoles,
		notificationsIconCount,
		forename,
		username,
		allowedToEditReferralSettings,
		allowedToEditPremiumSettings,
		allowedToEditEditingSettings,
		allowedToEditArticles,
		allowedToEditTobas,
		isNavbarOpen,
		setIsNavbarOpen,
	} = props;

	const showMobileMenu = useDelayedClose(isNavbarOpen, 300);
	const advanceDisbursementsEnabled = useFeatureFlag(FEATURE_FLAGS.ADVANCE_DISBURSEMENTS_ENABLED);

	const ADMIN_MENU = [
		{
			href: HREF_NEW_USER,
			callback: (e) => { callbackHandler(e, HREF_NEW_USER, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.CREATE_USER,
			testId: 'header-arag-users-create'
		},
		{
			href: HREF_USERS,
			callback: (e) => { callbackHandler(e, HREF_USERS, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.VIEW_USERS,
			testId: 'header-arag-users-view'
		},
	];
	const USER_MENU = [];
	if (isAragUser(userRoles) && !isAdminUser(userRoles)) {
		USER_MENU.push({
			label: CONTENT_STRINGS.MANAGE_ACCOUNT,
			href: HREF_MANAGE_USER_ACCOUNT,
			callback: (e) => { callbackHandler(e, HREF_MANAGE_USER_ACCOUNT, setIsNavbarOpen, push); },
			testId: 'header-manage-account'
		});
	}
	USER_MENU.push({
		label: CONTENT_STRINGS.LOG_OFF,
		callback: (e) => { logOff(e); },
		testId: 'header-logoff'
	});
	
	let settingsMenu = [];
	
	if (allowedToEditEditingSettings) {
		settingsMenu.push({
			href: HREF_EDITING_SETTINGS,
			callback: (e) => { callbackHandler(e, HREF_EDITING_SETTINGS, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.EDITING_SETTINGS,
			testId: 'header-settings-editing'
		});
	}

	if (allowedToEditReferralSettings) {
		settingsMenu.push({
			href: HREF_REFERRAL_SETTINGS,
			callback: (e) => { callbackHandler(e, HREF_REFERRAL_SETTINGS, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.REFERRAL_SETTINGS,
			testId: 'header-settings-referral'
		});
	}

	if (allowedToEditPremiumSettings) {
		settingsMenu.push({
			href: PREMIUM_SETTINGS_URL,
			callback: (e) => { callbackHandler(e, PREMIUM_SETTINGS_URL, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.PREMIUM_SETTINGS,
			testId: 'header-settings-premium'
		});
	}

	if (allowedToEditArticles) {
		settingsMenu.push({
			href: HREF_ARTICLES,
			callback: (e) => { callbackHandler(e, HREF_ARTICLES, setIsNavbarOpen, push); },
			label: CONTENT_STRINGS.ARTICLES,
			testId: 'header-settings-articles'
		});
	}

	if (allowedToEditTobas) {
		settingsMenu.push({
			href: `/solicitors/${TOBA_PATH}s`,
			callback: (e) => { callbackHandler(e, `/solicitors/${TOBA_PATH}s`, setIsNavbarOpen, push); },
			label: `${TOBA_SHORT_TEXT}s`,
			testId: 'header-settings-tobas'
		});
	}

	settingsMenu.push({
		href: HREF_INTERNAL_ALERTS,
		callback: (e) => { callbackHandler(e, HREF_INTERNAL_ALERTS, setIsNavbarOpen, push); },
		label: CONTENT_STRINGS.INTERNAL_ALERTS,
		testId: 'header-settings-internal-alerts'
	});

	let agentsMenu = [];
	agentsMenu.push({
		href: HREF_SOLICITORS,
		callback: (e) => { callbackHandler(e, HREF_SOLICITORS, setIsNavbarOpen, push); },
		label: `${LEGAL_ADVICE_TEXT}s (ATE)`,
		testId: 'header-users-solicitors'
	});
	const logOff = (e) => {
		e.preventDefault();
		logout();
	}
	const dropdownLabel = isAragUser(userRoles) && !isAdminUser(userRoles) ? forename : username
	return (
		<div className={'row user-layout-header'}>
			<div className={'col-sm-12 user-layout-header-row-1'}>
				<NavBar variant={SECONDARY}>
					<NavContainer navContainerTestId={'header'} variant={SECONDARY}>
						<NavHeader
							href={HREF_HOME}
							onBarsClick={() => setIsNavbarOpen(!isNavbarOpen)}
							onClick={(e) => { callbackHandler(e, HREF_HOME, setIsNavbarOpen, push); }}
							navHeaderTestId={'header-logo'}
							variant={SECONDARY}
						>
							<img className={'user-layout-header-logo'} src={aragLogo} alt={'arag logo'} />
						</NavHeader>
						<NavContent expanded={isNavbarOpen} variant={SECONDARY} onClose={() => setIsNavbarOpen(false)}>
							<NavBarMain navBarTestId={'header-nav-bar'} variant={SECONDARY}>
								{
									isAdminUser(userRoles)
									?
										showMobileMenu
										?
											ADMIN_MENU.map((item) => (
												<NavLink
													key={item.testId}
													href={item.href}
													onClick={item.callback}
													navLinkTestId={item.testId}
													variant={SECONDARY}
													active={locationPathName === item.href}
												>
													{item.label}
												</NavLink>
											))
										:
											<NavMenu
												id={'admin-menu'}
												options={ADMIN_MENU}
												dropdownLabel={CONTENT_STRINGS.ARAG_USERS}
												navMenuTestId={'header-arag-users'}
												variant={SECONDARY}
												active={ADMIN_MENU.some(i => locationPathName === i.href)}
											/>
									:
										null
								}
								{
									isAragUser(userRoles) && agentsMenu.length > 0
									?
										showMobileMenu
										?
											agentsMenu.map((item) => (
												<NavLink
													key={item.testId}
													href={item.href}
													onClick={item.callback}
													navLinkTestId={item.testId}
													variant={SECONDARY}
													active={locationPathName === item.href}
												>
													{item.label}
												</NavLink>
											))
										:
											<NavMenu
												id={'agents-menu'}
												options={agentsMenu}
												dropdownLabel={CONTENT_STRINGS.USERS}
												navMenuTestId={'header-users'}
												variant={SECONDARY}
												active={locationPathName === HREF_SOLICITORS}
											/>
									: 
										null
								}
								{
									isAragUser(userRoles)
									?
										<NavLink
											href={HREF_APPLICATION_AND_POLICIES}
											onClick={(e) => { callbackHandler(e, HREF_APPLICATION_AND_POLICIES, setIsNavbarOpen, push); }}
											navLinkTestId={"header-application"}
											variant={SECONDARY}
											active={locationPathName === HREF_APPLICATION_AND_POLICIES}
										>
											{CONTENT_STRINGS.APPLICATIONS_AND_POLICIES}
										</NavLink>
									: 
										null
								}
								{
									isAragUser(userRoles) && advanceDisbursementsEnabled
									?
										<NavLink
											href={HREF_ADVANCE_DISBURSEMENTS}
											onClick={
												(e) => { callbackHandler(e, HREF_ADVANCE_DISBURSEMENTS, setIsNavbarOpen, push);}
											}
											active={locationPathName === HREF_ADVANCE_DISBURSEMENTS}
											variant={SECONDARY}
											navLinkTestId={"header-advance-disbursements"}
										>
											{CONTENT_STRINGS.ADVANCE_DISBURSEMENTS}
										</NavLink>
									:
										null
								}
								{
									isAragUser(userRoles)
									?
										<NavLink
											href={HREF_NOTIFICATIONS}
											onClick={(e) => { callbackHandler(e, HREF_NOTIFICATIONS, setIsNavbarOpen, push); }}
											navLinkTestId={'header-notifications'}
											variant={SECONDARY}
											active={locationPathName === HREF_NOTIFICATIONS}
										>
											{CONTENT_STRINGS.NOTIFICATIONS} {notificationsIconCount > 0 ? <span className={'notifications-icon'}>{notificationsIconCount}</span> : null}
										</NavLink>
									:
										null
								}
								{
									isAragUser(userRoles) && settingsMenu.length > 0
									?
										showMobileMenu
										?
											settingsMenu.map((item) => (
												<div key={item.testId}>
													<NavLink
														href={item.href}
														onClick={item.callback}
														navLinkTestId={item.testId}
														variant={SECONDARY}
														active={locationPathName === item.href}
													>
														{item.label}
													</NavLink>
												</div>
											))
										:
											<NavMenu
												id={'settings-menu'}
												options={settingsMenu}
												dropdownLabel={CONTENT_STRINGS.SETTINGS}
												navMenuTestId={'header-settings'}
												variant={SECONDARY}
												active={settingsMenu.some(i => locationPathName === i.href)}
											/>
									:
										null
								}
							</NavBarMain>
							{
								showMobileMenu
								? 
									USER_MENU.map((item) => (
										<div key={item.testId}>
											<NavLink
												href={item.href}
												onClick={item.callback}
												navLinkTestId={item.testId}
												variant={SECONDARY}
												active={locationPathName === item.href}
											>
												{item.label}
											</NavLink>
										</div>
									))
								: 
									<NavUser
										id={'user-menu'}
										dropdownLabel={dropdownLabel}
										options={USER_MENU}
										navUserTestId={'header-user'}
										variant={SECONDARY}
									/>
							}
						</NavContent>
					</NavContainer>
				</NavBar>
			</div>
			<div className={'col-sm-12'}>
				<HorizontalRule variant={HEADER}/>
			</div>
			<div className={'col-sm-12'}>
				<BreadCrumb
					PathName={locationPathName}
					Push={push}
					BreadcrumbStyle={'user-layout-footer-breadcrumb'}
					Wrapper={'user-layout-footer-breadcrumb-wrapper'}
					breadcrumbTestId={'header-breadcrumb'}
				/>
			</div>
		</div>
	)
};

export default LayoutHeader;